import React from "react";
import {
  Filter,
  Create,
  TextInput,
  LongTextInput,
  SaveButton,
  BooleanInput,
  List,
  Datagrid,
  TextField,
  Pagination,
  Button,
  Link,
  Toolbar,
  Edit,
  SimpleForm,
  EditButton
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { TextBooleanField } from "../components/TextBooleanField";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const TourZoneTitle = object => (
  <span>
    {" Edit Zone entry "} {object.record.description_en}
  </span>
);

const TourZoneCreateTitle = record => <span>Create Tour Zone entry</span>;

const TourZonesListFilter = props => (
  <Filter {...props}>
    <TextInput label="Description" source="description_en" alwaysOn />
  </Filter>
);

export const TourZonesList = props => (
  <List
    {...props}
    title="TourZones"
    resource="tour_zones"
    bulkActionButtons={false}
    pagination={<ListPagination />}
    filters={<TourZonesListFilter />}
  >
    <Datagrid>
      <TextField label="ID" source="id" />
      <TextField label="Description" source="description_en" />
      <TextBooleanField label="Status (visible)" source="active" />
      <EditButton />
    </Datagrid>
  </List>
);

const TourZonesToolbar = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/tour_zones`} />
    <Button
      component={Link}
      to={{
        pathname: `/tour_zones`
      }}
      label="Back to TourZones"
    >
      <ArrowBackIcon />
    </Button>
  </Toolbar>
);

export const TourZonesEdit = props => (
  <Edit title={<TourZoneTitle />} {...props}>
    <SimpleForm toolbar={<TourZonesToolbar props={{ ...props }} />}>
      <LongTextInput label="Description (EN)" source="description_en" />
      <LongTextInput label="Description (ES)" source="description_es" />
      <LongTextInput label="Description (DE)" source="description_de" />
      <LongTextInput label="Description (PT)" source="description_pt" />
      <BooleanInput source="active" label="Status (visible)" />
    </SimpleForm>
  </Edit>
);

export const TourZonesCreate = props => (
  <Create title={<TourZoneCreateTitle />} {...props}>
    <SimpleForm toolbar={<TourZonesToolbar props={{ ...props }} />}>
      <LongTextInput label="Description (EN)" source="description_en" />
      <LongTextInput label="Description (ES)" source="description_es" />
      <LongTextInput label="Description (DE)" source="description_de" />
      <LongTextInput label="Description (PT)" source="description_pt" />
      <BooleanInput source="active" label="Status (visible)" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/tourZones.js